module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#instagram",
      toString: function () {
        return this.url;
      }
    }